import { render, staticRenderFns } from "./ReportSupplierDesignate.vue?vue&type=template&id=7c2c8a67"
import script from "./ReportSupplierDesignate.vue?vue&type=script&lang=js"
export * from "./ReportSupplierDesignate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports